const priceSelectorV2 = {
  init: function () {
    console.log("Init productSelectorV2");
    const that = this;
    //const isEs = window.isES;
    const isEs = false;

    // ES-dependent toggles (safe to run repeatedly)
    if (isEs) {
      document.querySelectorAll(".pdp-selector").forEach(function (selector) {
        const isComplementaryProduct =
          selector.classList.contains("complementary-product");
        if (isComplementaryProduct) return;

        selector.querySelectorAll(".es-dependent").forEach(function (el) {
          el.classList.add("es-dependent-show");
        });
      });
    }

    // Init each selector (safe after swaps / partial re-renders)
    document.querySelectorAll(".pdp-selector").forEach(function (pdpElement) {
      that.initSelector(pdpElement);
    });

    // Amazon redirect: intercept at document capture so no other handler redirects this tab
    if (!window.__amazonOtpQty1RedirectCaptureBound) {
      window.__amazonOtpQty1RedirectCaptureBound = true;
      document.addEventListener(
        "click",
        function (e) {
          priceSelectorV2.amazonRedirectDocumentCaptureHandler(e);
        },
        true
      );
    }

    // Gift info modal (global overlay) - bind once per trigger element
    document
      .querySelectorAll(".product-selector .js-open-gift-info")
      .forEach(function (el) {
        if (el.dataset.giftInfoInit === "true") return;
        el.dataset.giftInfoInit = "true";

        const subCard = el.closest(".pdp-card.pdp-sub-card");
        const isBundle = subCard && subCard.dataset.showBulkPrice === "true";
        if (isBundle) return;

        const pdpSelectorRoot = el.closest(".pdp-selector");
        if (!pdpSelectorRoot) return;

        const allFreqs = [];
        pdpSelectorRoot
          .querySelectorAll(".pdp-card.pdp-sub-card")
          .forEach(function (card) {
            const freq = card.dataset.freq;
            const qty = card.dataset.qty;
            if (freq && qty > 1) allFreqs.push(freq);
          });

        allFreqs.sort((a, b) => a - b);
        const lower = allFreqs.shift();
        const higher = allFreqs.pop();

        const giftInfoModalOverlay = document.querySelector(
          ".gift-info-modal-overlay"
        );
        if (!lower || !higher || !giftInfoModalOverlay) return;

        el.addEventListener("click", function () {
          const freq = el.closest(".pdp-card.pdp-sub-card")?.dataset.freq;
          if (!freq) return;

          giftInfoModalOverlay
            .querySelectorAll(".month-lower")
            .forEach(function (elLower) {
              elLower.textContent = lower;
            });
          giftInfoModalOverlay
            .querySelectorAll(".month-higher")
            .forEach(function (elHigher) {
              elHigher.textContent = higher;
            });

          giftInfoModalOverlay
            .querySelectorAll(".modal-header")
            .forEach(function (modalHeader) {
              if (
                (modalHeader.classList.contains("modal-header-lower") &&
                  freq == lower) ||
                (modalHeader.classList.contains("modal-header-higher") &&
                  freq == higher)
              ) {
                modalHeader.style.display = "block";
              } else {
                modalHeader.style.display = "none";
              }
            });

          giftInfoModalOverlay
            .querySelector(".month-toggle .three")
            ?.classList.toggle("selected", freq == lower);
          giftInfoModalOverlay
            .querySelector(".month-toggle .six")
            ?.classList.toggle("selected", freq == higher);

          giftInfoModalOverlay.classList.add("show-modal");
        });
      });
  },

  initSelector: function (pdpElement) {
    if (!pdpElement) return;

    // Mark initialized, but DO NOT bail early.
    // section-render-pdp can swap innerHTML while keeping the same container node;
    // we rely on per-element dataset guards below to prevent double-binding.
    pdpElement.dataset.psInit = "true";

    const pdpCardActiveClass = "pdp-active";

    // Card click handler (bind once per card)
    pdpElement.querySelectorAll(".pdp-card").forEach(function (card) {
      if (card.dataset.psCardInit === "true") return;
      card.dataset.psCardInit = "true";

      card.addEventListener("click", function (e) {
        e.stopPropagation();

        const root = this.closest(".pdp-selector");
        if (!root) return;

        const isSS = this.classList.contains("pdp-card-single");

        // prevent duplicate click from select interaction
        if (
          this.classList.contains(pdpCardActiveClass) ||
          e.target.nodeName.toUpperCase() === "SELECT"
        ) {
          return;
        }

        const pdpDetails = root.querySelector(".pdp-selector-details");
        if (!pdpDetails) return;

        const wasSSActive = root
          .querySelector("." + pdpCardActiveClass)
          ?.classList.contains("pdp-card-single");

        if (wasSSActive && window.hasShoppingParam) {
          return;
        } else {
          root.querySelectorAll(".pdp-card").forEach(function (el) {
            el.classList.remove(pdpCardActiveClass);
          });
          this.classList.add(pdpCardActiveClass);
        }

        priceSelectorV2.updateAmazonCtaForSelector(root);

        if (!isSS && wasSSActive) {
          pdpDetails.classList.add("pdp-hide-freq");
          clearTimeout(root.dataset.detailToggleTimer);
          root.dataset.detailToggleTimer = setTimeout(() => {
            const freqEl = pdpDetails.querySelector(".pdp-freq-selected");
            if (freqEl) freqEl.textContent = this.dataset.freq;

            pdpDetails.classList.remove("pdp-hide-freq");
            pdpDetails.querySelector(".pdp-subscription-content").style.display =
              "block";

            const ssContent = pdpDetails.querySelector(".pdp-ss-content");
            if (ssContent) ssContent.style.display = "none";

            pdpDetails.querySelector(".pdp-details-content").style.display =
              "block";
          }, 400);
        } else if (isSS && !wasSSActive) {
          pdpDetails.classList.add("pdp-hide-freq");
          clearTimeout(root.dataset.detailToggleTimer);
          root.dataset.detailToggleTimer = setTimeout(() => {
            pdpDetails.classList.remove("pdp-hide-freq");

            pdpDetails.querySelector(".pdp-subscription-content").style.display =
              "none";

            const ssContent = pdpDetails.querySelector(".pdp-ss-content");
            if (ssContent) ssContent.style.display = "flex";

            pdpDetails.querySelector(".pdp-details-content").style.display =
              "none";
          }, 400);
        } else if (!isSS && !wasSSActive) {
          pdpDetails.classList.add("pdp-hide-freq");
          clearTimeout(root.dataset.detailToggleTimer);
          root.dataset.detailToggleTimer = setTimeout(() => {
            const freqEl = pdpDetails.querySelector(".pdp-freq-selected");
            if (freqEl) freqEl.textContent = this.dataset.freq;

            pdpDetails.classList.remove("pdp-hide-freq");
            pdpDetails.querySelector(".pdp-subscription-content").style.display =
              "block";

            const ssContent = pdpDetails.querySelector(".pdp-ss-content");
            if (ssContent) ssContent.style.display = "none";

            pdpDetails.querySelector(".pdp-details-content").style.display =
              "block";
          }, 400);
        } else if (isSS && wasSSActive) {
          pdpDetails.classList.remove("pdp-hide-freq");
          pdpDetails.querySelector(".pdp-subscription-content").style.display =
            "none";

          const ssContent = pdpDetails.querySelector(".pdp-ss-content");
          if (ssContent) ssContent.style.display = "flex";

          pdpDetails.querySelector(".pdp-details-content").style.display = "none";
        }
      });
    });

    // Add to cart buttons inside this selector
    pdpElement.querySelectorAll(".js-add-item-btn").forEach(function (btn) {
      if (btn.dataset.psAddInit === "true") return;
      btn.dataset.psAddInit = "true";
      btn.addEventListener("click", priceSelectorV2.addToCartHandler);
    });

    // Add click handlers for benefits buttons (scoped to this selector)
    pdpElement
      .querySelectorAll(".pdp-card-view-all-benefits")
      .forEach(function (el) {
        if (el.dataset.psBenefitsInit === "true") return;
        el.dataset.psBenefitsInit = "true";

        el.addEventListener("click", function (e) {
          if (e.target.closest(".benefits-link")) return;

          const detailsContent = this.closest(".pdp-selector-details")
            ?.querySelector(".pdp-details-content");
          if (!detailsContent) return;

          const isVisible = detailsContent.style.display !== "none";
          detailsContent.style.display = isVisible ? "none" : "flex";

          const buttonText = this.querySelector(".benefits-link");
          if (buttonText) {
            if (isVisible) {
              buttonText.textContent = buttonText.textContent.replace(
                "View",
                "Hide"
              );
            } else {
              buttonText.textContent = buttonText.textContent.replace(
                "Hide",
                "View"
              );
            }
          }
        });
      });

    // SS dropdowns inside this selector
    pdpElement
      .querySelectorAll(".pdp-card-ss-qty-dropdown select")
      .forEach(function (selectEl) {
        if (selectEl.dataset.psSsInit === "true") return;
        selectEl.dataset.psSsInit = "true";

        const handler = function () {
          this.closest(".pdp-card-single")?.dispatchEvent(new Event("click"));
          priceSelectorV2.ssCardSelectEvent(this);
        };

        selectEl.addEventListener("change", handler);
        selectEl.addEventListener("click", handler);
      });

    // Premium selector link inside this selector
    pdpElement
      .querySelectorAll(".pdp-card-premium .premium-link a")
      .forEach(function (premiumLink) {
        if (premiumLink.dataset.psPremiumInit === "true") return;
        premiumLink.dataset.psPremiumInit = "true";

        const variantId =
          premiumLink.closest(".pdp-card-premium")?.dataset.variantId;
        if (!variantId) return;

        premiumLink.addEventListener("click", function (e) {
          priceSelectorV2.addToCart(
            {
              id: variantId,
              quantity: 1,
              properties: priceSelectorV2.getIgPricesForSelector(
                e.currentTarget.closest(".pdp-selector")
              ),
            },
            null
          );
        });
      });

    // Default activate a card (per selector)
    const cardToActivate =
      pdpElement.querySelector(
        window.hasShoppingParam
          ? ".pdp-card-single"
          : ".pdp-card.default-active"
      ) || pdpElement.querySelector(".pdp-card");

    cardToActivate?.dispatchEvent(new Event("click"));

    priceSelectorV2.updateAmazonCtaForSelector(pdpElement);
  },

  getIgPricesForSelector: function (pdpSelector) {
    console.log("getIgPricesForSelector");
    const prices = {};
    pdpSelector
      .querySelectorAll(".pdp-sub-card[data-variant-id]")
      .forEach(function (el) {
        const igPrice = window.igData.price.getPriceByVariantId(
          el.dataset.variantId
        );
        if (igPrice) {
          prices[`_igp_${el.dataset.variantId}`] = igPrice * 100;
        }
      });
    return prices;
  },

  addToCartHandler: function (e) {
    window.Sentry?.setTag("action", "add_to_cart");
    const pdpSelector = e.currentTarget.closest(".pdp-selector");
    if (!pdpSelector) return;

    const productSelector = pdpSelector.closest(".product-selector");
    if (!productSelector) return;

    const card = pdpSelector.querySelector(".pdp-card.pdp-active");
    if (!card) return;

    const giftModalOverlay = document.querySelector(".gift-modal-overlay");

    const isSS = card.classList.contains("pdp-card-single");
    const qty = isSS
      ? card.querySelector(".pdp-card-ss-qty-dropdown select")?.value
      : card.dataset.qty;

    const amazonOtpQty1Url = pdpSelector.dataset.amazonOtpQty1Url;
    if (amazonOtpQty1Url && isSS && String(qty) === "1") {
      console.log(
        "[OTP qty=1] redirecting to Amazon:",
        amazonOtpQty1Url
      );
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      priceSelectorV2.openUrlInNewTab(amazonOtpQty1Url);
      return;
    }

    const cartItem = {
      id: card.dataset.variantId,
      quantity: 1,
      properties: priceSelectorV2.getIgPricesForSelector(pdpSelector),
    };

    if (card.dataset.sellingPlan) {
      cartItem.selling_plan = card.dataset.sellingPlan;
    }

    const noCheckoutRedirect = pdpSelector.classList.contains(
      "no-checkout-redirect"
    );

    const isComplementaryProduct = pdpSelector.classList.contains(
      "complementary-product"
    );

    const isBundle = card.dataset.showBulkPrice === "true";

    if (
      window.isES &&
      !isSS &&
      qty > 1 &&
      giftModalOverlay &&
      !isComplementaryProduct &&
      !isBundle
    ) {
      giftModalOverlay.querySelector(".modal").dataset.cartItem =
        JSON.stringify(cartItem);
      giftModalOverlay.querySelector(".modal").dataset.noCheckoutRedirect =
        pdpSelector.classList.contains("no-checkout-redirect") ? 1 : 0;
      giftModalOverlay.classList.add("show-modal");
      return false;
    }

    console.log("addToCart");
    console.log(cartItem);

    priceSelectorV2.addToCart(
      cartItem,
      null,
      noCheckoutRedirect,
      isComplementaryProduct
    );
  },

  amazonRedirectCaptureHandler: function (e) {
    const pdpSelector = e.currentTarget.closest(".pdp-selector");
    if (!pdpSelector) {
      return;
    }
    const card = pdpSelector.querySelector(".pdp-card.pdp-active");
    if (!card || !card.classList.contains("pdp-card-single")) {
      return;
    }
    const qty = card.querySelector(".pdp-card-ss-qty-dropdown select")?.value;
    const amazonOtpQty1Url = pdpSelector.dataset.amazonOtpQty1Url;
    if (!amazonOtpQty1Url || String(qty) !== "1") {
      return;
    }

    console.log("[OTP qty=1] redirecting to Amazon:", amazonOtpQty1Url);
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    priceSelectorV2.openUrlInNewTab(amazonOtpQty1Url);
  },

  amazonRedirectDocumentCaptureHandler: function (e) {
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    const firstEl = path.find((n) => n instanceof Element);
    const btn = firstEl?.closest?.(".js-add-item-btn");
    if (!btn) {
      return;
    }
    const pdpSelector = btn.closest(".pdp-selector");
    if (!pdpSelector) {
      return;
    }
    const amazonOtpQty1Url = pdpSelector.dataset.amazonOtpQty1Url;
    if (!amazonOtpQty1Url) {
      return;
    }
    const card = pdpSelector.querySelector(".pdp-card.pdp-active");
    if (!card || !card.classList.contains("pdp-card-single")) {
      return;
    }
    const qty = card.querySelector(".pdp-card-ss-qty-dropdown select")?.value;
    if (String(qty) !== "1") {
      return;
    }

    console.log("[OTP qty=1] redirecting to Amazon:", amazonOtpQty1Url);
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    priceSelectorV2.openUrlInNewTab(amazonOtpQty1Url);
  },

  openUrlInNewTab: function (url) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
  },

  /**
   * Callback for when Intelligems runs `window.postMessage("ig-ready");` to
   * indicate that the window.igData object may be used.
   */
  onIgReady: function () {
    console.log("onIgReady");
    document.querySelectorAll(".pdp-selector").forEach(function (selectorEl) {
      console.log("selectorEl:", selectorEl);

      const qtyOneCard = selectorEl.querySelector(
        '.pdp-sub-card[data-canonical-quantity="1"]'
      );
      if (!qtyOneCard) {
        console.log("No qty=1 card found, skipping igData price calculation");
        return;
      }

      const basePrice =
        window.igData.price.getComparePriceByVariantId(
          qtyOneCard.dataset.variantId
        ) || qtyOneCard.dataset.basePrice;

      selectorEl.querySelectorAll(".pdp-sub-card").forEach(function (subCard) {
        const itemBasePrice = basePrice * subCard.dataset.canonicalQuantity;
        subCard.dataset.basePrice = itemBasePrice;

        const itemBulkDiscountedPrice =
          window.igData.price.getPriceByVariantId(subCard.dataset.variantId) ||
          subCard.dataset.bulkPrice;

        subCard.dataset.bulkPrice = itemBulkDiscountedPrice;

        let fullyDiscountedPrice =
          itemBulkDiscountedPrice -
          (itemBulkDiscountedPrice * subCard.dataset.subDiscountPercentage) /
            100;

        const discountAmount = itemBasePrice - fullyDiscountedPrice;
        const discountPercentage = (discountAmount * 100) / itemBasePrice;

        subCard.dataset.discountPercentage = discountPercentage;

        subCard.querySelector(".js-pdp-sub-card-perc-off").innerText =
          Math.round(discountPercentage);

        subCard.querySelector(".js-pdp-sub-card-total-off").innerText =
          "$" + (discountAmount.toFixed(2) + "");

        const isBundle = subCard.dataset.showBulkPrice === "true";
        const perUnitPrice = fullyDiscountedPrice / subCard.dataset.qty;
        const displayPrice = isBundle ? fullyDiscountedPrice : perUnitPrice;

        const priceParts = displayPrice.toFixed(2).split(".");
        const priceDollars = Math.trunc(priceParts[0]);
        const priceCents = priceParts[1];

        const priceDollarsSpan = subCard?.querySelector(
          ".pdp-card-price-dollars span"
        );
        const priceCentsSpan = subCard?.querySelector(".pdp-card-price-cents");

        if (priceDollarsSpan) {
          priceDollarsSpan.innerText = priceDollars;
        } else {
          const priceDollarsNoSpan = subCard?.querySelector(
            ".pdp-card-price-dollars"
          );
          if (priceDollarsNoSpan) priceDollarsNoSpan.innerText = priceDollars;
        }
        if (priceCentsSpan) priceCentsSpan.innerText = priceCents;
      });

      selectorEl.querySelectorAll(".pdp-card-ss-qty-dropdown option").forEach(
        function (optionEl, idx) {
          const itemBulkDiscountedPrice =
            window.igData.price.getPriceByVariantId(optionEl.dataset.id) ||
            optionEl.dataset.price;

          let fullyDiscountedPrice = itemBulkDiscountedPrice;

          window.igData.campaigns
            .getAll()
            .filter(function (campaign) {
              if (campaign.discount.testProducts.length === 0) return true;
              if (/fd2e298e7540$/.test(campaign.campaignId)) return false;

              for (let k = 0; k < campaign.discount.testProducts.length; k++) {
                for (
                  let m = 0;
                  m < campaign.discount.testProducts[k].variants.length;
                  m++
                ) {
                  if (
                    campaign.discount.testProducts[k].variants[m].id ==
                    optionEl.dataset.id
                  ) {
                    return true;
                  }
                }
              }
              return false;
            })
            .forEach(function (campaign) {
              const applicableTiers = campaign.discount.tiers
                .filter(function (tier) {
                  if (tier.isFreeShipping || tier.isGiftWithPurchase)
                    return false;

                  switch (campaign.discount.unitType) {
                    case "unit":
                      return (
                        optionEl.value >= tier.minimumUnits &&
                        optionEl.value <= tier.maximumUnits
                      );
                    case "dollar":
                      return (
                        itemBulkDiscountedPrice >= tier.minimumUnits &&
                        itemBulkDiscountedPrice <= tier.maximumUnits
                      );
                    default:
                      console.error(
                        "Unsupported discount.unitType",
                        campaign.discount.unitType
                      );
                      return false;
                  }
                })
                .sort(function (tierA, tierB) {
                  return tierB.minimumUnits - tierA.minimumUnits;
                });

              if (applicableTiers.length === 0) return;

              switch (campaign.discount.discountType) {
                case "percentage":
                  fullyDiscountedPrice -=
                    (itemBulkDiscountedPrice *
                      applicableTiers[0].unitDiscount) /
                    100;
                  break;
                case "dollar":
                  fullyDiscountedPrice -= applicableTiers[0].unitDiscount;
                  break;
                default:
                  console.error(
                    "Unsupported discount.discountType",
                    campaign.discount.discountType
                  );
                  break;
              }
            });

          if (!optionEl.dataset.priceRendered) {
            if (fullyDiscountedPrice < 0) fullyDiscountedPrice = 0;

            const premiumLink = selectorEl.querySelector(".premium-link a");
            if (premiumLink && idx == 0) {
              premiumLink.innerText =
                "Buy Once for $" +
                parseFloat(fullyDiscountedPrice).toFixed(2) +
                (fullyDiscountedPrice < 45 ? " + $5.95 shipping" : "");
            }

            optionEl.dataset.price = fullyDiscountedPrice;

            const discountPercentage =
              100 - (fullyDiscountedPrice / optionEl.dataset.basePrice) * 100;

            optionEl.dataset.discountPercentage = discountPercentage.toFixed(0);
            optionEl.dataset.percentText =
              discountPercentage < 0.1
                ? "Market Price"
                : "Save " + discountPercentage.toFixed(0) + "%";

            const unitPrice = fullyDiscountedPrice / optionEl.value;
            const perDayCost = unitPrice / selectorEl.dataset.supplyDays;
            const unitPriceParts = (unitPrice.toFixed(2) + "").split(".");

            optionEl.dataset.each = unitPrice;
            optionEl.dataset.savingsText =
              "Only $" + perDayCost.toFixed(2) + " per day";
            optionEl.dataset.eachDollars = unitPriceParts[0];
            optionEl.dataset.eachCents = unitPriceParts[1];
            optionEl.dataset.priceRendered = true;

            priceSelectorV2.ssCardSelectEvent(optionEl.closest("select"));
          }
        }
      );

        // Hive 335373 Beyond Collagen 124 vs 136 test
        if (selectorEl.closest("#pricing-area__product--beyond-collagen") && 'beyondCollagenQtyTest' in window) {
          // removing sub cards
          for (const card of selectorEl.querySelectorAll(".pdp-sub-card")) {
            const qty = parseInt(card.dataset.qty);
            if (
              (window.beyondCollagenQtyTest === 0 && [3, 6].includes(qty)) ||
              (window.beyondCollagenQtyTest === 1 && [2, 4].includes(qty))
            ) {
              card.remove();
            }
          }
          // removing options from dropdowns
          for (const option of selectorEl.querySelectorAll(".pdp-card-ss-qty-dropdown select option")) {
            const optionQty = parseInt(option.value);
            if (
              (window.beyondCollagenQtyTest === 0 && [3, 6].includes(optionQty)) ||
              (window.beyondCollagenQtyTest === 1 && [2, 4].includes(optionQty))
            ) {
              option.remove();
            }
          }

          // selecting the second option in dropdowns and sub cards
          const secondOption = selectorEl.querySelector(".pdp-card-ss-qty-dropdown select option:nth-child(2)");
          if (secondOption) {
            secondOption.selected = true;
          }
          selectorEl.querySelector(".pdp-sub-card:is([data-qty='4'], [data-qty='6'])")?.dispatchEvent(new Event("click"));

          // setting pdp-card-first and pdp-card-last classes for styling purposes
          const allSubCard = selectorEl.querySelectorAll(".pdp-sub-card");
          allSubCard[0]?.classList.add("pdp-card-first");
          const lastSubCard = allSubCard[allSubCard.length - 1];
          if (lastSubCard) {
            lastSubCard.classList.add("pdp-card-last");
          }
        }
      }
    );
  }, // End onIgReadyCallback

  addToCart: function (
    item,
    giftVariantId,
    noCheckoutRedirect,
    isComplementaryProduct
  ) {
    this.miniCart = document.querySelector("mini-cart");
    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const cart = {
      items: [item],
      sections: sections,
      sections_url: window.location.pathname,
    };

    if (giftVariantId) {
      cart.items.push({
        id: giftVariantId,
        quantity: 1,
        properties: { _igGWP: "1" },
      });
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cart),
    })
      .then((response) => response.json())
      .then((response) => {
        document
          .querySelectorAll(".modal-overlay.show-modal")
          .forEach((modalOverlay) => modalOverlay.classList.remove("show-modal"));

        if (this.miniCart) {
          this.miniCart.renderContents(response);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
          });

          if (isComplementaryProduct) {
            const complementaryProductCta = document.querySelector(
              ".complementary-product-add"
            );
            if (complementaryProductCta) {
              const buttonText = complementaryProductCta.querySelector("div");
              if (buttonText) buttonText.textContent = "ADDED";

              complementaryProductCta.setAttribute("disabled", "true");
              complementaryProductCta.style.opacity = "0.6";
              complementaryProductCta.style.cursor = "not-allowed";
              complementaryProductCta.style.backgroundColor = "#6B7280";
            }
          }

          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", { detail: { product: response } })
          );
        } else {
          window.location.href = "/checkout";
        }
      })
      .catch((error) => console.error("Err:", error));
  },

  ssCardSelectEvent: function (element) {
    const pdpElement = element.closest(".pdp-selector");
    if (!pdpElement) return;

    const ssCard = pdpElement.querySelector(".pdp-card-single");
    if (!ssCard) return;

    const selected = element.options[element.selectedIndex];
    if (element.options.length === 1) {
      ssCard.dataset.basePrice = ssCard.dataset.basePrice;
    } else {
      ssCard.dataset.basePrice = selected.dataset.basePrice;
    }
    ssCard.dataset.bulkPrice = selected.dataset.price;
    ssCard.dataset.variantId = selected.dataset.id;
    ssCard.dataset.discountPercentage = selected.dataset.discountPercentage;

    const isCollagenBundle = ssCard.dataset.showBulkPrice === "true";

    if (isCollagenBundle) {
      const bulkPrice = parseFloat(selected.dataset.price);
      const bulkPriceParts = bulkPrice.toFixed(2).split(".");
      ssCard.querySelector(".pdp-card-price-dollars").textContent =
        "$" + bulkPriceParts[0];
      ssCard.querySelector(".pdp-card-price-cents").textContent =
        bulkPriceParts[1];

      const perDayPrice = (
        bulkPrice /
        parseFloat(selected.dataset.canonicalQuantity) /
        30
      ).toFixed(2);
      ssCard.querySelector(".pdp-card-saving-amount").textContent =
        `Only $${perDayPrice} per day`;
    } else {
      ssCard.querySelector(".pdp-card-price-dollars").textContent =
        "$" + selected.dataset.eachDollars;
      ssCard.querySelector(".pdp-card-price-cents").textContent =
        selected.dataset.eachCents;
      ssCard.querySelector(".pdp-card-saving-amount").textContent =
        selected.dataset.savingsText;
    }

    ssCard.querySelector(".pdp-card-saving-percent span").textContent =
      selected.dataset.percentText;

    priceSelectorV2.updateAmazonCtaForSelector(pdpElement);
  },

  updateAmazonCtaForSelector: function (pdpSelector) {
    if (!pdpSelector) {
      return;
    }

    const btn = pdpSelector.querySelector(".js-add-item-btn");
    if (!btn) {
      return;
    }

    if (!btn.dataset.defaultText) {
      btn.dataset.defaultText = (btn.textContent || "").trim();
    }

    const amazonOtpQty1Url = pdpSelector.dataset.amazonOtpQty1Url;
    const activeCard = pdpSelector.querySelector(".pdp-card.pdp-active");
    const isSS = !!activeCard?.classList.contains("pdp-card-single");
    const qty = isSS
      ? activeCard.querySelector(".pdp-card-ss-qty-dropdown select")?.value
      : null;

    const shouldAmazonRedirect =
      !!amazonOtpQty1Url && isSS && String(qty) === "1";

    btn.classList.toggle("amazon-redirect-active", shouldAmazonRedirect);
    btn.dataset.amazonRedirectActive = shouldAmazonRedirect ? "true" : "false";
    btn.textContent = shouldAmazonRedirect ? "Buy on Amazon" : btn.dataset.defaultText;
  },

  triggerAllSSCardSelects: function () {
    document
      .querySelectorAll(".pdp-card-ss-qty-dropdown select")
      .forEach(function (el) {
        priceSelectorV2.ssCardSelectEvent(el);
        const ssCard = el.closest(".pdp-card-single");
        if (ssCard?.classList.contains("pdp-active")) {
          ssCard.dispatchEvent(new Event("click"));
        }
      });
  },

  setPremiumSelector: function (showPremium) {
    document.querySelectorAll(".premium-dependent").forEach(function (el) {
      el.classList.toggle("premium-dependent-show", showPremium);
    });
    document.querySelectorAll(".not-premium-dependent").forEach(function (el) {
      el.classList.toggle("not-premium-dependent-show", !showPremium);
    });
  },

  renderContents: function (parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
  },

  getSectionsToRender: function () {
    return [
      { id: "mini-cart", section: "mini-cart", selector: ".shopify-section" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  },

  getSectionInnerHTML: function (html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  },
};

if (window.igReadyAggregator?.addIgReadyListener) {
  window.igReadyAggregator.addIgReadyListener(function () {
    priceSelectorV2.onIgReady();
    priceSelectorV2.triggerAllSSCardSelects();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    priceSelectorV2.init();
  });
} else {
  priceSelectorV2.init();
}

document.addEventListener("pdp:swapped", function () {
  priceSelectorV2.init();
  // If igData is ready, refresh selector prices after swap
  if (window.igData?.price) {
    priceSelectorV2.onIgReady();
    priceSelectorV2.triggerAllSSCardSelects();
  }
});

window.addEventListener("pageshow", function () {
  priceSelectorV2.triggerAllSSCardSelects();
});

window.priceSelectorV2 = priceSelectorV2;